// extracted by mini-css-extract-plugin
export default {"TextArea":"TextArea_TextArea__eoJRc","RevertButtonWrapper":"TextArea_RevertButtonWrapper__IJT31"};